import React from "react";

import Voucher from "features/vouchers";
import Str from "shared/components/Str";
import FOOTER_LINK from "shared/constants/footerLink";

const guestLinks = [
	{
		href: "/s/chicago-dating",
		name: "Chicago Dating",
	},
	{
		href: "/s/washington-dating",
		name: "Washington Dating",
	},
	{
		href: "/s/seattle-dating",
		name: "Seattle Dating",
	},
	{
		href: "/s/los-angeles-dating",
		name: "Los Angeles Dating",
	},
	{
		href: "/s/philadelphia-dating",
		name: "Philadelphia Dating",
	},
	{
		href: "/s/atlanta-dating",
		name: "Atlanta Dating",
	},
	{
		href: "/s/nyc-dating",
		name: "NYC Dating",
	},
	{
		href: "/s/christian-singles",
		name: "Christian Singles",
	},
	{
		href: "/s/jewish-singles",
		name: "Jewish Singles",
	},
	{
		href: "/s/spiritual-singles",
		name: "Spiritual Singles",
	},
	{
		href: "/s/muslim-dating",
		name: "Muslim Dating",
	},
	{
		href: "/s/gay-dating",
		name: "Gay Dating",
	},
	{
		href: "/s/bisexual-dating",
		name: "Bisexual Dating",
	},
	{
		href: "/s/lesbian-dating",
		name: "Lesbian Dating",
	},
	{
		href: "/s/liberal-dating-sites",
		name: "Liberal Dating",
	},
	{
		href: "/s/vegan-dating",
		name: "Vegan Dating",
	},
	{
		href: "/s/vegetarian-dating",
		name: "Vegetarian Dating",
	},
	{
		href: "/s/conservative-dating-sites",
		name: "Conservative Dating",
	},
];

export const links = [
	FOOTER_LINK.Apps,
	FOOTER_LINK.About,
	FOOTER_LINK.AdChoices,
	FOOTER_LINK.Press,
	FOOTER_LINK.Careers,
	FOOTER_LINK.Support,
	FOOTER_LINK.Blog,
	FOOTER_LINK.TechBlog,
	guestLinks[Math.floor(Math.random() * guestLinks.length)],
	FOOTER_LINK.Privacy,
	FOOTER_LINK.Cookies,
	FOOTER_LINK.Terms,
	FOOTER_LINK.CommunityGuidelines,
	FOOTER_LINK.Safety,
	FOOTER_LINK.Security,
];

const Footer = () => {
	const onClickRedeemVoucher = () => {
		Voucher.open();
	};

	return (
		<div className="splashdtf-footer">
			<div className="splashdtf-footer-links">
				<ul className="splashdtf-footer-nav">
					{links.map((link) => (
						<li key={link.href} className="splashdtf-footer-nav-item">
							<a className="splashdtf-footer-nav-item-link" href={link.href}>
								{link.name}
							</a>
						</li>
					))}
					<li className="splashdtf-footer-nav-item">
						<button
							className="splashdtf-footer-nav-item-link-button"
							onClick={onClickRedeemVoucher} >
							<Str>Redeem Promotion</Str>
						</button>
					</li>
				</ul>

				<div className="splashdtf-footer-copyright">
					© OkCupid {new Date().getFullYear()}
				</div>
			</div>
			<div className="splashdtf-footer-social">
				<a
					className="splashdtf-footer-social-circle facebook"
					target="_blank"
					rel="noopener noreferrer"
					href="https://facebook.com/okcupid"
				>
					<i className="okicon i-facebook" />
				</a>
				<a
					className="splashdtf-footer-social-circle instagram"
					target="_blank"
					rel="noopener noreferrer"
					href="https://instagram.com/okcupid"
				>
					<i className="okicon i-instagram" />
				</a>
				<a
					className="splashdtf-footer-social-circle twitter"
					target="_blank"
					rel="noopener noreferrer"
					href="https://twitter.com/okcupid"
				>
					<i className="okicon i-twitter" />
				</a>
			</div>
		</div>
	);
};

export default Footer;



// WEBPACK FOOTER //
// ./src/apps/splash_desktop/components/Footer.jsx